/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DatabaseTemplateCategory
 */
export interface DatabaseTemplateCategory {
    /**
     * 
     * @type {string}
     * @memberof DatabaseTemplateCategory
     */
    readonly id?: string;
    /**
     * 
     * @type {string}
     * @memberof DatabaseTemplateCategory
     */
    name?: string;
    /**
     * Das Zeichen der Themenwelt im Vorlagenkatalog — ein Font-Awesome-Name wie `fa-box-archive`.
     * WARUM AN DER THEMENWELT (06.10.2026): Bisher stand eine Zuordnung Name -> Zeichen fest im Frontend. Eine neue Themenwelt bekam damit das allgemeine Datenbank-Sinnbild, bis jemand den Quelltext anfasst; eine umbenannte verlor ihr Zeichen stillschweigend.
     * LEER IST ERLAUBT und heisst "nimm das aus dem Namen abgeleitete" — so sehen bestehende Themenwelten aus wie bisher.
     * @type {string}
     * @memberof DatabaseTemplateCategory
     */
    icon?: string;
}

/**
 * Check if a given object implements the DatabaseTemplateCategory interface.
 */
export function instanceOfDatabaseTemplateCategory(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DatabaseTemplateCategoryFromJSON(json: any): DatabaseTemplateCategory {
    return DatabaseTemplateCategoryFromJSONTyped(json, false);
}

export function DatabaseTemplateCategoryFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatabaseTemplateCategory {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'icon': !exists(json, 'icon') ? undefined : json['icon'],
    };
}

export function DatabaseTemplateCategoryToJSON(value?: DatabaseTemplateCategory | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'icon': value.icon,
    };
}

